import { Platform } from 'react-native';
import { convertTokenValueToRems } from '@/common/theme/utils';
import { TGap } from '@/common/theme/variants';
import { spacing } from '@coverflex-tech/hypernova-design-tokens';

const halfSpacingTokens = Object.fromEntries(
  Object.entries(spacing.mobile).map(([key, value]) => [key, value / 2])
);

// Nativewind doesn't convert REM units when using vars() helper,
// so we will just use them in Web.
const halfSpacingTokensRems =
  Platform.OS === 'web'
    ? convertTokenValueToRems(halfSpacingTokens)
    : halfSpacingTokens;

export const gridMarginVars = Object.entries(halfSpacingTokensRems).reduce(
  (acc, [key, value]) => {
    acc[`--grid-margin-${key}`] = value;
    return acc;
  },
  {} as Record<string, string>
);

export const rootMarginVariants = (rowGap?: TGap, columnGap?: TGap) => {
  const columnGapVariants = {
    '2xs': '-mx-[--grid-margin-2xs]',
    xs: '-mx-[--grid-margin-xs]',
    sm: '-mx-[--grid-margin-sm]',
    md: '-mx-[--grid-margin-md]',
    lg: '-mx-[--grid-margin-lg]',
    xl: '-mx-[--grid-margin-xl]',
    '2xl': '-mx-[--grid-margin-2xl]',
    page: '-mx-[--grid-margin-xl]',
    section: '-mx-[--grid-margin-md] md:-mx-[--grid-margin-lg]',
    container: '-mx-[--grid-margin-md]',
    form: '-mx-[--grid-margin-md]',
    'sibling-card': '-mx-[--grid-margin-md]',
  } satisfies Record<TGap, string>;

  const rowGapVariants = {
    '2xs': '-my-[--grid-margin-2xs]',
    xs: '-my-[--grid-margin-xs]',
    sm: '-my-[--grid-margin-sm]',
    md: '-my-[--grid-margin-md]',
    lg: '-my-[--grid-margin-lg]',
    xl: '-my-[--grid-margin-xl]',
    '2xl': '-my-[--grid-margin-2xl]',
    page: '-my-[--grid-margin-xl]',
    section: '-my-[--grid-margin-md] md:-my-[--grid-margin-lg]',
    container: '-my-[--grid-margin-md]',
    form: '-my-[--grid-margin-md]',
    'sibling-card': '-my-[--grid-margin-md]',
  } satisfies Record<TGap, string>;

  return `${rowGap ? rowGapVariants[rowGap] : ''} ${
    columnGap ? columnGapVariants[columnGap] : ''
  }`;
};

export const childMarginVariants = (rowGap?: TGap, columnGap?: TGap) => {
  const childColumnGapVariants = {
    '2xs': 'mx-[--grid-margin-2xs]',
    xs: 'mx-[--grid-margin-xs]',
    sm: 'mx-[--grid-margin-sm]',
    md: 'mx-[--grid-margin-md]',
    lg: 'mx-[--grid-margin-lg]',
    xl: 'mx-[--grid-margin-xl]',
    '2xl': 'mx-[--grid-margin-2xl]',
    page: 'mx-[--grid-margin-xl]',
    section: 'mx-[--grid-margin-md] md:mx-[--grid-margin-lg]',
    container: 'mx-[--grid-margin-md]',
    form: 'mx-[--grid-margin-md]',
    'sibling-card': 'mx-[--grid-margin-md]',
  } satisfies Record<TGap, string>;

  const childRowGapVariants = {
    '2xs': 'my-[--grid-margin-2xs]',
    xs: 'my-[--grid-margin-xs]',
    sm: 'my-[--grid-margin-sm]',
    md: 'my-[--grid-margin-md]',
    lg: 'my-[--grid-margin-lg]',
    xl: 'my-[--grid-margin-xl]',
    '2xl': 'my-[--grid-margin-2xl]',
    page: 'my-[--grid-margin-xl]',
    section: 'my-[--grid-margin-md] md:my-[--grid-margin-lg]',
    container: 'my-[--grid-margin-md]',
    form: 'my-[--grid-margin-md]',
    'sibling-card': 'my-[--grid-margin-md]',
  } satisfies Record<TGap, string>;

  return `${rowGap ? childRowGapVariants[rowGap] : ''} ${
    columnGap ? childColumnGapVariants[columnGap] : ''
  }`;
};
